import React, { Component } from 'react';
import i18n from 'i18n-react';

import apple from 'assets/images/app_store.png';
import google from 'assets/images/google_play.png';
import { BackImage, DataHandler, StorageHandler } from 'C4';
import { productLinks, storageKeys } from 'settings';

export default class MobileWarning extends Component {
  constructor(props) {
    super(props);

    this.state = {
      appId: 0,
      appName: '',
    };
  }

  componentWillMount() {
    DataHandler.matchAppId().then((app) => {
      this.setState({ appId: app });
    });
  }

  componentDidMount() {
    this.getAppInfo();
  }

  getAppInfo() {
    StorageHandler.load(storageKeys.appInfo).then((res) => {
      if (res) {
        this.setState({ appName: res.appName });
      }
    });
  }

  render() {
    const { appName } = this.state;
    return (
      <div>
        <div className="container__mobileButtons">
          <BackImage darken />
          <div className="container__mobileButtons__holder">
            <h2>{"It looks like you're trying to access the app from a mobile device"}</h2>
            <section>{`To download the ${appName} MicroModule simply visit your app store and search for TheSOURCE or click one of the buttons below`}
            </section>
            <h5>{"This will provide you with:"}
            </h5>
            <ul>
              <li>{"Portability"}</li>
              <li>{"No need for WiFi, train when and where convenient"}
              </li>
              <li>{"Sales tools & resources at your fingertips"}
              </li>
            </ul>
            <div className="buttons">
              <a href={productLinks.ios}>
                <img src={apple} alt="App store" />
              </a>
              <a href={productLinks.android}>
                <img src={google} alt="Google Play" />
              </a>
            </div>
            <hr />
            <span>{"App: "}{this.state.appId}</span>
          </div>
        </div>
      </div>
    );
  }
}
